<template>
  <v-dialog
    v-model="computedElectricalSubstationsVisibility"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card>
        <!-- close icon -->
        <v-btn
          icon
          @click="
            methodToggleSingleLayer('electrical', 'substations', false);
            disable_edit = true;
          "
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <span>{{ computedSubName }}</span>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <!-- edit icon -->
        <v-tooltip bottom>
          <v-btn
            icon
            slot="activator"
            :disabled="computedAuthProfile != 'maintenance'"
            @click="disable_edit = !disable_edit"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <span>Edit</span>
        </v-tooltip>
      </v-toolbar>
      <div
        style="background-color: black; padding-left: 30px; overflow:auto; -webkit-overflow-scrolling:touch;"
      >
        <v-data-table
          :items="computedElectricalSubstationsGeoJsonFeature"
          :loading="computedElectricalSubstationsLoading"
          :hide-actions="hideactions"
          :hide-headers="hideheaders"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td>Schematics</td>
              <td>
                <v-btn
                  :key="key"
                  v-for="(value, key) in props.item.properties.jpg.split(',')"
                  small
                  color="info"
                  @click="
                    methodViewSchematic(value);
                    imageDesc = methodSchematicDesc(key);
                  "
                  style="margin-left: 0px;"
                  >{{ methodSchematicDesc(key) }}</v-btn
                >
              </td>
            </tr>
            <tr>
              <td>Mountain</td>
              <td>{{ props.item.properties.mountain }}</td>
            </tr>
            <tr>
              <td>Site</td>
              <td>{{ props.item.properties.site }}</td>
            </tr>
            <tr>
              <td>Name</td>
              <td>{{ props.item.properties.sub_name }}</td>
            </tr>
            <tr>
              <td>Acro</td>
              <td>{{ props.item.properties.acro }}</td>
            </tr>
            <tr>
              <td>Sub Type</td>
              <td>{{ props.item.properties.sub_type }}</td>
            </tr>
            <tr>
              <td>Transformer Type</td>
              <td>{{ props.item.properties.trans_type }}</td>
            </tr>
            <tr>
              <td>Transformer Size</td>
              <td>{{ props.item.properties.trans_size }}</td>
            </tr>
            <tr>
              <td>Switch Type</td>
              <td>{{ props.item.properties.swit_type }}</td>
            </tr>
            <tr>
              <td>Drawing #</td>
              <td>{{ props.item.properties.draw_num }}</td>
            </tr>
            <tr>
              <td>Comments</td>
              <td>
                <v-textarea
                  ref="substations_comments"
                  v-model="props.item.properties.comments"
                  :disabled="disable_edit"
                ></v-textarea>
              </td>
            </tr>
            <tr>
              <td>Last Edited</td>
              <td>
                <span v-if="disable_edit">{{
                  props.item.properties.edit_by
                }}</span>
                <span v-if="!disable_edit">
                  {{ computedAuth.profile.email }}
                </span>
              </td>
            </tr>
            <tr>
              <td>Modified</td>
              <td>
                <span v-if="disable_edit">{{
                  props.item.properties.modified
                }}</span>
                <span v-if="!disable_edit">
                  {{ getNormalDate(Date.now()) }}
                </span>
              </td>
            </tr>
          </template>
          <template slot="footer">
            <tr>
              <td colspan="100%">
                <v-spacer class="hidden-sm-and-down"></v-spacer>
                <v-btn
                  @click.stop="
                    methodEditElectricalSubstationsGeoJson({
                      energized: $refs.substations_energized.value.text,
                      comments: $refs.substations_comments.value,
                      edit_by: computedAuth.profile.email
                    });
                    disable_edit = true;
                    methodToggleSingleLayer('electrical', 'substations', false);
                  "
                  :disabled="disable_edit"
                  color="success"
                  >Save</v-btn
                >
                <v-spacer class="hidden-sm-and-down"></v-spacer>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div style="flex: 1 1 auto;"></div>
    </v-card>
    <!-- image viewer dialog -->
    <v-dialog
      v-model="imageViewer"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar>
          <v-btn icon @click.native="imageViewer = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ imageDesc }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            icon
            :href="
              'https://app.wbsnowmaking.com/electrical/substations/file/' +
                imageFilename
            "
            target="_blank"
            rel="noopener"
          >
            <v-icon>zoom_in</v-icon>
          </v-btn>
        </v-toolbar>

        <v-content style="padding-left:0px">
          <v-layout>
            <v-img
              v-if="computedElectricalSubstationsVisibility"
              :src="
                'https://app.wbsnowmaking.com/electrical/substations/file/' +
                  imageFilename
              "
              height="700"
              contain
            />
          </v-layout>
        </v-content>
      </v-card>
      <div style="flex: 1 1 auto;"></div>
    </v-dialog>
  </v-dialog>
  <!-- image viewer dialog -->
</template>

<style scoped>
.content {
  max-height: 100%;
  max-width: 100%;
  padding: 0px !important;
  display: inline-block;
}
table {
  padding-top: 20px;
}
</style>
<script>
export default {
  data() {
    return {
      imageViewer: false,
      imageFilename: "",
      imageDesc: "",
      loading: true,
      persistent: false,
      hideheaders: true,
      hideactions: true,
      solo: true,
      disable_edit: true,
      opt_energized: [{ text: "Yes" }, { text: "No" }]
    };
  },
  computed: {
    computedSubName() {
      if (this.computedElectricalSubstationsVisibility) {
        const substations = this.$store.state.mapLayers.electrical.layers
          .substations.geojson.features;
        // grabs the lift_name of the currently viewed ID
        let result = substations.filter(
          item => item.properties.id == this.computedElectricalSubstationsId
        );
        return result[0].properties.sub_name;
      }
      return [];
    },
    computedElectricalSubstationsGeoJsonFeature() {
      if (
        this.$store.state.mapLayers.electrical.layers.substations.geojson
          .features
      ) {
        const substations = this.$store.state.mapLayers.electrical.layers
          .substations.geojson.features;
        const result = substations.filter(
          item => item.properties.id == this.computedElectricalSubstationsId
        );
        return result;
      }
      return [];
    },
    computedElectricalSubstationsVisibility() {
      return this.$store.state.mapLayers.electrical.layers.substations
        .visibility.singleView;
    },
    computedElectricalSubstationsLoading() {
      return this.$store.state.mapLayers.electrical.layers.substations.loading;
    },
    computedElectricalSubstationsId() {
      return this.$store.state.mapLayers.electrical.layers.substations
        .visibility.singleId;
    },
    computedAuth() {
      return this.$store.state.auth;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    methodSchematicDesc(key) {
      if (this.computedElectricalSubstationsVisibility) {
        const substations = this.$store.state.mapLayers.electrical.layers
          .substations.geojson.features;
        let result = substations.filter(
          item => item.properties.id == this.computedElectricalSubstationsId
        );
        return result[0].properties.descriptio.split(",")[key];
      }
    },
    methodViewSchematic(value) {
      this.imageFilename = value;
      this.imageViewer = true;
    },
    getNormalDate(utcdate) {
      // utc date is a string like 2018-04-16T21:52:58.811Z
      let date = new Date(utcdate);
      let y = date.getFullYear();
      let m = date.getMonth();
      let d = date.getDay();
      return y + "-" + m + "-" + d;
    },
    // method to get geojson
    methodGetElectricalSubstationsGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/electrical/substations",
        dept: "electrical",
        layer: "substations",
        token: this.computedAuthToken
      });
    },
    methodEditElectricalSubstationsGeoJson(data) {
      this.$store.dispatch("actionEditGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/electrical/substations/" +
          this.computedElectricalSubstationsId,
        dept: "",
        layer: "substations",
        token: this.computedAuthToken,
        payload: data
      });
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.electrical.layers.substations.visibility.singleView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetElectricalSubstationsGeoJson();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.electrical.layers.substations.geojson": function(
      newValue
    ) {
      if (newValue) {
        this.loading = false;
      }
    }
  }
};
</script>
